import React, { forwardRef } from 'react'

import Box from '@material-ui/core/Box'

const RowComponent = (props, ref) => <Box ref={ref} display='flex' flexDirection='row' {...props} />

export default forwardRef(RowComponent)
